<template>

  <div class="grid-container alignmentComponent">

    <h6>The Benefits of Proper Alignment</h6>

    <div class="grid-x grid-margin-x grid-margin-y contentSection alignment-50" style="margin:15px 0 !important;">
      <article class="cell small-12 medium-5" :class="index % 2 !== 0 ? 'medium-offset-1' : null"  v-for="(content, index) in alignmentContent" :key="index">
        <div class="alignmentIcons">
        <img class="iconContainer" :src="content.icon" :alt="content.alt">
        <p style="margin-bottom: 0 !important;">{{content.text}}</p>
        </div>
      </article>
    </div>

  </div>

</template>

<script>
export default {
  name: 'ComponentAlignment',
  props: ['alignmentContent']
}   
</script>

<style scoped>

.alignmentComponent {
  max-width: 800px; 
}
.alignment-50 {
  margin-top: 50px;
}
.alignmentIcons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.iconContainer {
  height: 70px;
}
</style>